import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { WorkClassification } from "src/app/shared/Models/hourentry";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ClassificationService {
  private apiUrl = `${environment.apiRoot}WorkClassifications`;

  constructor(private http: HttpClient) {}

  getClassifications(projectId: number): Observable<WorkClassification[]> {
    return this.http.get<WorkClassification[]>(`${this.apiUrl}/getAll/${projectId}`).pipe(
      map((classifications: WorkClassification[]) =>
        classifications.map(classification => this.instantiateClassification(classification))
      )
    );
  }

  getClassification(id: number): Observable<WorkClassification> {
    return this.http.get<WorkClassification>(`${this.apiUrl}/${id}`).pipe(
      map((classification: WorkClassification) => this.instantiateClassification(classification))
    );
    return this.http.get<WorkClassification>(`${this.apiUrl}/${id}`).pipe(
      map((classification: WorkClassification) => this.instantiateClassification(classification))
    );
  }
  private instantiateClassification(classification: WorkClassification): WorkClassification {
    const classificationInstance = new WorkClassification();
    classificationInstance.id = classification.id;
    classificationInstance.name = classification.name;
    classificationInstance.description = classification.description;
    classificationInstance.projectId = classification.projectId;
    classificationInstance.parentId = classification.parentId;
    classificationInstance.templateId = classification.templateId;
    classificationInstance.templateNodeId = classification.templateNodeId;

    // Recursively instantiate subclassifications
    classificationInstance.children = classification.children
      ? classification.children.map(subClassification =>
          this.instantiateClassification(subClassification)
        )
      : [];

    return classificationInstance;
  }
  createClassification(classification: WorkClassification): Observable<WorkClassification> {
    return this.http.post<WorkClassification>(this.apiUrl, classification).pipe(
      map((classification: WorkClassification) => this.instantiateClassification(classification))
    );
  }
  getParentClassifications(classificationId:number): Observable<WorkClassification[]> {
    return this.http.get<WorkClassification[]>(`${this.apiUrl}/getAllParents/${classificationId}`).pipe(
      map((classifications: WorkClassification[]) =>
        classifications.map(classification => this.instantiateClassification(classification))
      )
    );
  }
  updateClassification(classification: WorkClassification): Observable<WorkClassification> {
    return this.http.put<WorkClassification>(`${this.apiUrl}/${classification.id}`, classification).pipe(
      map((classification: WorkClassification) => this.instantiateClassification(classification))
    );
  }
  copyClassifications(fromProject:number, toProject:number): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/copy/${fromProject}/${toProject}`,null);
  }
  deleteClassification(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
